import React, { useState } from "react";
import { Copy, Check } from "lucide-react";

// Malé tlačítko pro rychlé zkopírování hodnoty (telefon, email, účet...).
// Po kliknutí ukáže na 1,5 s fajfku. Fallback pro prostředí bez clipboard API.
// Používá se u kontaktů klientů i týmu, ať jde číslo/adresa rovnou vložit
// do telefonu, SMS nebo mailu.
export default function CopyButton({ value, title = "Zkopírovat", className = "" }) {
  const [done, setDone] = useState(false);
  if (!value) return null;
  const copy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const text = String(value).trim();
    try {
      await navigator.clipboard.writeText(text);
    } catch (_) {
      // Starší prohlížeče / http kontext
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); } catch (_2) { /* nevadí */ }
      ta.remove();
    }
    setDone(true);
    setTimeout(() => setDone(false), 1500);
  };
  return (
    <button
      type="button"
      onClick={copy}
      title={done ? "Zkopírováno!" : title}
      aria-label={title}
      className={`inline-flex items-center justify-center w-6 h-6 rounded-lg border transition-colors align-middle shrink-0 ${
        done
          ? "bg-emerald-50 border-emerald-200 text-emerald-600"
          : "bg-white/80 border-slate-200 text-slate-400 hover:text-brand-600 hover:border-brand-200 hover:bg-brand-50"
      } ${className}`}
    >
      {done ? <Check className="w-3.5 h-3.5" /> : <Copy className="w-3.5 h-3.5" />}
    </button>
  );
}
